import React from 'react';
import { ReviewContactDetails } from 'pages/components';

const ScreeningContactReview = (props) => (
  <ReviewContactDetails {...props} />
);

export default ScreeningContactReview;
